exports = module.exports = require("../../../../css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".erg-components-ClearFilter{cursor:pointer}", "", {"version":3,"sources":["/./node_modules/@ergeon/erg-components-react/lib/filters/node_modules/@ergeon/erg-components-react/lib/filters/ClearFilter.scss"],"names":[],"mappings":"AAAA,4BACE,cAAe,CAChB","file":"ClearFilter.scss","sourcesContent":[".erg-components-ClearFilter {\n  cursor: pointer;\n}\n"],"sourceRoot":"webpack://"}]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader?sourceMap!./~/sass-loader?sourceMap&includePaths[]=/home/circleci/project/bower_components&includePaths[]=/home/circleci/project/node_modules!./~/postcss-loader!./~/@ergeon/erg-components-react/lib/filters/ClearFilter.scss
 ** module id = 1151
 ** module chunks = 0
 **/